export default __webpack_public_path__ + "static/media/proof_tip.3fd6cb00.svg";